<template>
  <div>

    <create-checklist-dictionary-popup
      v-if="showAddModal"
      @close="showAddModal = false"
      @submitted="refreshData(); showAddModal = false;"
    />

    <b-card
      no-body
      class="mb-0"
    >

      <table-top
        show-add-button
        show-search
        @change:limit="limitChanged"
        @change:query="queryChanged"
        @click:add="showAddModal = true "
      />

      <rc-overlay :show="loading">
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="checklistDictionaries"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="loading ? $t('shared.loading') : $t('shared.no-data') "
          :sort-by.sync="query.sortBy"
          :sort-desc.sync="query.isSortDirDesc"
        >

          <!-- Column: Value -->
          <template #cell(value)="data">
            <b-media vertical-align="center">
              <b-link
                :to="{ name: 'settings-checklist-dictionary-edit', params: { id: data.item.id } }"
                class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.value }}
              </b-link>
            </b-media>
          </template>

          <!-- Column: active -->
          <template #cell(active)="data">
            <b-avatar
              v-if="data.item.active"
              variant="light-success"
              size="24"
            >
              <feather-icon
                icon="CheckIcon"
              />
            </b-avatar>
            <b-avatar
              v-else
              variant="light-danger"
              size="24"
            >
              <feather-icon
                icon="XIcon"
              />
            </b-avatar>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">
              <feather-icon
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="editChecklistDictionary(data.item.id)"
              />
              <b-tooltip
                :title="$t('shared.edit')"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-send-icon`"
              />
            </div>

          </template>

        </b-table>
      </rc-overlay>

      <table-bottom
        :query="query"
        :total="total"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BAvatar,
  BCard, BLink, BMedia, BTable, BTooltip,
} from 'bootstrap-vue'
import TableTop from '@/layouts/components/table/TableTop.vue'
import CreateChecklistDictionaryPopup from '@/views/settings/ChecklistDictionary/popups/CreateChecklistDictionaryPopup.vue'
import TableBottom from '@/layouts/components/table/TableBottom.vue'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import { parseRequestError } from '@/helpers/helpers'

export default {
  components: {
    TableBottom,
    CreateChecklistDictionaryPopup,
    TableTop,
    RcOverlay,

    BCard,
    BTable,
    BMedia,
    BLink,
    BTooltip,
    BAvatar,
  },
  data() {
    return {
      showAddModal: false,
      loading: false,

      total: 0,
      query: {
        sortBy: null,
        isSortDirDesc: false,
        query: null,
        limit: 10,
        page: 1,
      },

      tableColumns: [
        {
          label: this.$t('conf.settings.checklist-dictionary.value'),
          key: 'value',
          sortable: true,
        },
        {
          label: this.$t('conf.settings.checklist-dictionary.active'),
          key: 'active',
          sortable: true,
        },
        {
          label: this.$t('shared.actions'),
          key: 'actions',
          value: null,
          class: 'actions-column',
        },
      ],
    }
  },
  computed: {
    checklistDictionaries() {
      return this.$store.state.settings.checklistDictionaries
    },
  },
  watch: {
    query: {
      handler() {
        this.refreshData()
      },
      deep: true,
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.loading = true
      const query = {
        q: this.query.query,
        sortField: this.query.sortBy,
        sortDir: this.query.isSortDirDesc ? 'desc' : 'asc',
        limit: this.query.limit,
        page: this.query.page,
      }

      Promise.all([this.$store.dispatch('settings/fetchChecklistDictionaries', query)])
        .then(res => {
          if (this.query.page > 1 && res[0].data.items.length === 0) {
            this.query.page = 1
          }

          this.total = res[0].data.total
          this.loading = false
        })
        .catch(err => parseRequestError(err))
    },
    deleteChecklistDictionary(id) {
      return id
    },
    editChecklistDictionary(id) {
      this.$router.push(`/settings/checklist-dictionary/edit/${id}`)
    },
    limitChanged(newLimit) {
      this.query.limit = newLimit
    },
    queryChanged(newQuery) {
      this.query.query = newQuery
    },
  },
}
</script>

<style lang="scss">

.actions-column {
  width: 1rem;
}
</style>
